import React from 'react'

import { ProductsCarousel } from '@peracto/peracto-blocks-tailwind'
import Form from './Form/ProductsCarouselForm'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }

    const RenderComponent = ProductsCarousel

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/productsCarousel',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            numberOfProducts: 4,
            progressIndicatorStyle: 'dots',
            imageFit: 'cover',
            fontFamily: '',
            fontWeight: 'normal',
            fontColour: '#000',
            accentColour: '#000',
            arrowColour: '#FFFFFF',
            fallbackImage: '',
            useSiloImages: false,
        }),
    }
}

export default createPlugin
